<template>
  <div
    class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6  sm:justify-center z-50"
  >
    <transition
      enter-active-class="transform ease-out duration-300 transition"
      enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
      leave-active-class="transition ease-in duration-100"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-show="showNotification"
        class="Polaris-Frame-ToastManager"
        aria-live="assertive"
      >
        <div
          class="Polaris-Frame-ToastManager__ToastWrapper Polaris-Frame-ToastManager--toastWrapperEnterDone"
          style="--pc-toast-manager-translate-y-in:-66px; --pc-toast-manager-translate-y-out:84px;"
        >
          <div class="Polaris-Frame-Toast">
            <div
              class="Polaris-Inline"
              style="--pc-inline-block-align:center; --pc-inline-wrap:wrap; --pc-inline-gap-xs:var(--p-space-4);"
            >
              <span
                class="Polaris-Text--root Polaris-Text--medium capitalize"
                >{{ text }}</span
              >
            </div>

            <button
              type="button"
              class="Polaris-Frame-Toast__CloseButton cursor-pointer z-50"
              @click="close"
            >
              <span class="Polaris-Icon"
                ><span
                  class="Polaris-Text--root Polaris-Text--visuallyHidden"
                ></span
                ><svg
                  viewBox="0 0 20 20"
                  class="Polaris-Icon__Svg"
                  focusable="false"
                  aria-hidden="true"
                >
                  <path
                    d="M6.707 5.293a1 1 0 0 0-1.414 1.414l3.293 3.293-3.293 3.293a1 1 0 1 0 1.414 1.414l3.293-3.293 3.293 3.293a1 1 0 0 0 1.414-1.414l-3.293-3.293 3.293-3.293a1 1 0 0 0-1.414-1.414l-3.293 3.293-3.293-3.293Z"
                  ></path>
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
      <!-- <div
        v-show="show"
        class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto "
      >
        <div class="rounded-lg shadow-xs overflow-hidden">
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <svg
                  class="h-6 w-6 text-green-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm leading-5 font-medium text-gray-900">
                  {{ text }}
                </p>
              </div>
              <div class="ml-4 flex-shrink-0 flex">
                <button
                  class="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                >
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path
                      fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      showNotification: false
    };
  },
  watch: {
    show(value) {
      this.showNotification = value;
    }
  },
  methods: {
    close() {
      this.showNotification = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
